// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__TSgCU","text--image":"Text_text--image__AJcxu","slides":"Text_slides__v4Bc1"};